var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6283 19.8183C15.8216 20.0567 14.8683 20.1667 13.75 20.1667H8.24998C7.13164 20.1667 6.17831 20.0567 5.37164 19.8183C5.57331 17.435 8.02081 15.5558 11 15.5558C13.9791 15.5558 16.4266 17.435 16.6283 19.8183Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.83333H8.24998C3.66665 1.83333 1.83331 3.66667 1.83331 8.25V13.75C1.83331 17.215 2.87831 19.1125 5.37165 19.8183C5.57331 17.435 8.02081 15.5558 11 15.5558C13.9791 15.5558 16.4266 17.435 16.6283 19.8183C19.1216 19.1125 20.1666 17.215 20.1666 13.75V8.25C20.1666 3.66667 18.3333 1.83333 13.75 1.83333ZM11 12.9892C9.18498 12.9892 7.71831 11.5133 7.71831 9.69835C7.71831 7.88335 9.18498 6.41667 11 6.41667C12.815 6.41667 14.2816 7.88335 14.2816 9.69835C14.2816 11.5133 12.815 12.9892 11 12.9892Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2817 9.69835C14.2817 11.5134 12.815 12.9892 11 12.9892C9.18499 12.9892 7.71832 11.5134 7.71832 9.69835C7.71832 7.88335 9.18499 6.41667 11 6.41667C12.815 6.41667 14.2817 7.88335 14.2817 9.69835Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.da1d9373fe9e1eceb8b9dcbe5061a3c4.svg";
export { ForwardRef as ReactComponent };